import styled from "styled-components"

import { Typography } from "components/common/index"

const PageSubTitle = styled(Typography).attrs(() => ({
  as: "h2",
}))`
  ${({ theme }) => `
    display: block;
    color: ${theme.colors.black};
    font-size: ${theme.fontSizes[16]};
    font-weight: bold;
    letter-spacing: 1.5px;
    margin-bottom: 24px;
    margin-top: 16px;
  `}
  ${({ theme }) => theme.mediaQueries.tablet`
    font-size: ${theme.fontSizes[20]};
  `};
`

export default PageSubTitle
